import { WlWindow } from 'typings/globals/cordova';

import {
  BookingConfirmed,
  BusinessEvent,
  BusinessEventHandler,
  CheckoutPageViewed,
  CookieConsentUpdate,
  ExperiencePageViewed,
} from '../../businessLayer';

declare const window: WlWindow;

const facebookAdsHandler: BusinessEventHandler = (evt: BusinessEvent) => {
  if (!window || !window.fbq) {
    return;
  }

  if (evt.type === 'CookieConsentUpdate') {
    const event = evt as CookieConsentUpdate;
    if (event.advertisement) {
      window.fbq('consent', 'grant');
      console.log('[FacebookAds] consent granted');
    } else {
      window.fbq('consent', 'revoke');
      console.log('[FacebookAds] consent revoked');
    }
  }

  if (evt.type === 'PageView') {
    window.fbq('track', 'PageView');
    console.log('[FacebookAds] PageView tracked');
  }

  if (evt.type === 'ExperiencePageViewed') {
    const event = evt as ExperiencePageViewed;
    const experienceId = event.experience?.id;
    const experienceTitle = event.experience?.title;

    window.fbq('track', 'ViewContent', {
      content_ids: experienceId ? [experienceId] : [],
      content_name: experienceTitle,
      content_type: 'product',
    });

    console.log('[FacebookAds] ViewContent tracked', {
      content_ids: experienceId ? [experienceId] : [],
      content_name: experienceTitle,
    });
  }

  if (evt.type === 'CheckoutPageViewed') {
    const event = evt as CheckoutPageViewed;
    const { experience_id, trip_title, trip_id, guest_id } =
      event.getEventData();

    window.fbq(
      'track',
      'InitiateCheckout',
      {
        content_ids: [experience_id],
        content_name: trip_title,
        content_type: 'product',
        external_id: guest_id,
      },
      { eventID: trip_id },
    );

    console.log('[FacebookAds] InitiateCheckout tracked', {
      content_ids: [experience_id],
      content_name: trip_title,
    });
  }

  if (evt.type === 'BookingConfirmed') {
    const event = evt as BookingConfirmed;
    const eventData = event.getEventData();

    window.fbq(
      'track',
      'Purchase',
      {
        value: eventData.amount,
        currency: eventData.currency,
        content_ids: [eventData.experience_id],
        content_name: eventData.trip_title,
        external_id: eventData.guest_id,
        order_id: eventData.trip_id,
      },
      { eventID: eventData.trip_id },
    );
    console.log('[FacebookAds] Purchase tracked', {
      value: eventData.amount,
      currency: eventData.currency,
      content_ids: [eventData.experience_id],
      content_name: eventData.trip_title,
    });
  }
};

export { facebookAdsHandler };
